import FormValidation from "../Validation/FormValidation";
import Form from "../Form";
import App from "../../../templates/src/App/App";
import FormRating from "../Inputs/Rating/Rating";

const FormDebug = {

    init(form) {
        this.el = form.prev('[component="FormDebug"]');
        if (!form.length || !this.el.length) return;
        if(App.debug) console.log('FormDebug.init() ->', form, this.el);

        this.select = this.el.find('select');
        this.checkbox = this.el.find('[type="checkbox"]');
        this.radio = this.el.find('div.radio');
        this.fillBtn = this.el.find('button.fill');
        this.clearBtn = this.el.find('button.clear');

        this.el.each((i, el) => {
            this.getParams($(el), form);
            this.bind($(el), form);
        })

    },

    getParams(el, form){

        // localStorage.setItem('FormDebug', 'Tom');

        // $.each(form[0].attributes, function() {
        //     console.log(this.name, this.value);
        // })

        this.radio.each((i, el) => {
            const attr = $(el).attr('name');
            const value = form.attr(attr)
            $(el).find('input[type="radio"][value="' + value + '"]').prop('checked', true)
        })

        this.select.each((i, el) => {
            const attr = $(el).attr('name');
            const value = form.attr(attr)
            $(el).val(value);
        })

        this.checkbox.each((i, el) => {
            const attr = $(el).attr('name');
            const value = form.attr(attr) !== "false";
            $(el).prop('checked', value);
        })
    },

    bind(el, form) {
        this.radio.find('input[type="radio"]').change((evt) => {
            const attr = $(evt.currentTarget).attr('name');
            form.attr(attr, $(evt.currentTarget).val());
        });

        this.select.change((evt) => {
            const name = $(evt.currentTarget).attr('name');
            form.attr(name, evt.currentTarget.value);
        });

        this.checkbox.change((evt) => {
            const name = $(evt.currentTarget).attr('name');
            form.attr(name, $(evt.currentTarget).prop('checked'));
        });

        this.fillBtn.click((evt) => {
           this.fill(form);
        });

        this.clearBtn.click((evt) => {
           Form.reset(form)
        });

    },

    fill(form) {
        form.find('.input').removeClass('invalid');
        form.find('[type="text"]').not('.chosen-search-input').val('Kŕdeľ ďatľov učí koňa žrať kôru');
        form.find('[type="password"]').val('Kŕdeľ ďatľov učí koňa žrať kôru');
        form.find('[type="url"]').val('Kŕdeľ ďatľov učí koňa žrať kôru');
        form.find('[type="password"]').val('Kŕdeľ ďatľov učí koňa žrať kôru');
        form.find('textarea').val('Kŕdeľ ďatľov učí koňa žrať kôru');
        form.find('[type="email"]').val('address@domain.com');
        form.find('[type="tel"]').val('0900123456');
        form.find('[type="number"]').val(77);
        form.find('.input.date [type="text"]').val('06.12.1975');
        form.find('select').each((i, el)=>{
            const option = $(el).find('option:nth-child(2)').attr('value');
            $(el).val(option).trigger('change');
        })
        form.find('select.chosen').trigger('chosen:updated');
        form.find('[type="checkbox"]').prop('checked', 'checked');
        form.find('.input.radio').each((i, el)=>{
            $(el).find('[type="radio"]').first().prop('checked', 'checked');
        })
        form.find('.input.rating').each((i, el)=>{
            $(el).find('input').val(3);
            FormRating.resetTo(3)
        })

    },

}
export default FormDebug;
